import { render, staticRenderFns } from "./UpdatePass.vue?vue&type=template&id=2142facc&scoped=true&"
import script from "./UpdatePass.vue?vue&type=script&lang=js&"
export * from "./UpdatePass.vue?vue&type=script&lang=js&"
import style0 from "./UpdatePass.vue?vue&type=style&index=0&id=2142facc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2142facc",
  null
  
)

export default component.exports